import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from 'common/formatters';

import {
  SR_API_ACTION_PARTNER_EDIT_LISTING,
} from 'api/actionTypes';

import {
  DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES,
} from 'common/dataTableConstants';

import postWithState from 'client/actions/postWithState';

import {
  actionDataTableReset,
} from 'client/helpers/dataTables';

import SrFlex from 'client/components/SrFlex';
import SrIcon from 'client/components/SrIcon';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import {
  BUTTON_THEME_GREEN_ADOBE,
} from 'client/components/ButtonDeprecated';

import './SrListingLowerPriceModal.less';

const SrListingLowerPriceModal = ({ listing, dispatch, onClose, onLowerRentPrice }) => {
  const [priceUpdated, setPriceUpdated] = useState(false);

  const onClickLowerPrice = () => {
    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_EDIT_LISTING,
      payload: {
        partnerId: listing.partnerId,
        listingId: listing.id,
        updates: { price: listing.comparativeMarketAnalysisRentPrice },
      },
      onSuccess: () => {
        setPriceUpdated(true);

        dispatch(actionDataTableReset, {
          dataSource: DATA_TABLE_SOURCE_PARTNER_LISTING_HISTORICAL_UPDATES,
        });

        if (onLowerRentPrice) {
          onLowerRentPrice();
        }
      },
    });
  };

  if (priceUpdated) {
    return (
      <SrSimpleMessageModal
        theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
        iconUrl='/images/checkmark-circle-large-green.svg'
        headline='Rent Price Updated'
        underline
        message={(
          <SrText
            font='greycliff'
            weight='600'
            color='grey'
            display='block'
            align='center'
            paddingRight='12px'
            paddingLeft='12px'
            lineHeight='25px'
          >
            This change is now visible on your property listing.
            <br /><br />
            Sunroom just alerted thousands of renters about your newly lowered price!
          </SrText>
        )}
        maxWidth={375}
        buttonText='Got it, thanks!'
        buttonTheme={BUTTON_THEME_GREEN_ADOBE}
        onClose={onClose}
        onButtonClick={onClose}
      />
    );
  }

  return (
    <SrSimpleMessageModal
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      headline='Lower the Rent Price'
      contentContainerClassName='srListingLowerPriceModal'
      message={(
        <>
          <div styleName='price-container'>
            <SrText
              display='block'
              font='greycliff'
              weight='800'
              size='28'
              align='center'
              lineHeight='34px'
              color='blue300'
            >
              {formatPrice(listing.comparativeMarketAnalysisRentPrice)}
            </SrText>
            <SrText
              display='block'
              align='center'
              size='13'
              lineHeight='16px'
              weight='800'
              font='greycliff'
              color='blue300'
            >
              CMA suggested price
            </SrText>
          </div>
          <div>
            <SrFlex justify='center' marginBottom='5px'>
              <SrIcon className='exclamation-mark-blue' />
            </SrFlex>
            <span styleName='description'>
              Send an alert to
              <span styleName='description strong'>{' thousands of renters '}</span>
              {`${listing.marketDisplayName ? `in ${listing.marketDisplayName}` : ''} `}
              by lowering the rent price now!
            </span>
            <SrFlex justify='center' marginTop='30px' marginBottom='5px'>
              <SrIcon className='leads-blue' />
            </SrFlex>
            <span styleName='description'>
              Get more leads by matching the rent price of competitors in your area!
            </span>
          </div>
        </>
      )}
      buttonText={`Lower Price to ${formatPrice(listing.comparativeMarketAnalysisRentPrice)}`}
      buttonTheme={BUTTON_THEME_GREEN_ADOBE}
      maxWidth={375}
      onClose={onClose}
      onButtonClick={onClickLowerPrice}
    />
  );
};

SrListingLowerPriceModal.propTypes = {
  listing: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onLowerRentPrice: PropTypes.func,
};

SrListingLowerPriceModal.displayName = 'SrListingLowerPriceModal';

export default SrListingLowerPriceModal;
